module.exports = __webpack_public_path__ + "img/ultra-high-vaccum-filter.af15801f.png";